export const DRESS_STYLE_OPTIONS = {
  lengths: [
    // Short to long
    "Mini - Above the knee",
    "Knee - At the knee",
    "Calf - At the mid-calf",
    "Ankle - At the ankle",
    "Floor - Just reaches the floor",
    "Chapel - Slight train (1-2 feet past feet)",
    "Cathedral - Long train (2-3 feet+)",
    "Royal - Very long, dramatic train",
  ],

  sleeves: [
    "Sleeveless - No sleeves",
    "Short - Above the elbow",
    "Elbow - At the elbow",
    "Three–Quarter - Below the elbow",
    "Long - Full length",
    "Bell - Flare out from elbow",
  ],

  sleeveAddons: [
    "Cutouts - Open shoulders",
    "Asymmetric - Remove the left or right sleeve",
  ],

  necklines: [
    "Off–Shoulder - Sits below shoulder line",
    "Plunge - Deep dramatic V-neck",
    "V - Classic V-neck opening",
    "Sweetheart - Heart-shaped curved neckline",
    "Scoop - Curved U-shaped neckline",
    "Draped - Soft, flowing fabric draping",
    "Boat - Wide opening to shoulders",
    "Straight - Horizontal, across chest",
    "Collared - Like a dress shirt",
    "Halter - Covers neck and chest, exposes back",
    "High - Conservative, covers neck, chest, and back",
    "Square - Straight neckline with squared corners",
  ],

  silhouettes: [
    "Ball Gown / Princess - Fitted bodice with a full, voluminous skirt",
    "A–Line - Fitted bodice with a gradually widening skirt",
    "Mermaid - Fitted down to the knees, then flares dramatically",
    "Trumpet - Fitted down to the mid-thigh, then flares dramatically",
    "Fit & Flare - Fitted through the waist and hips, then gently flares out",
    "Empire - Fitted just under the bust, then flares dramatically",
    "Sheath - Straight fit, body-hugging column shape",
    "Fitted - Tight on body throughout",
    "Drop–Waist - Fitted down to the waist/hips, then flares dramatically",
  ],

  fabrics: [
    "Cotton Blend - Breathable, budget-friendly everyday fabric",
    "Silk Charmeuse - Lustrous, lightweight silk with a smooth drape",
    "Duchess Satin - Heavyweight satin with a luxurious sheen and structure",
    "Mikado - Crisp silk blend with a subtle sheen and structured hand",
    "Organza - Sheer, crisp fabric often used for full skirts and overlays",
    "Tulle - Fine netting for volume, layering, and delicate details",
    "Velvet - Soft, pile fabric with a rich depth and warmth",
    "Crepe de Chine - Lightweight silk with a matte, slightly textured surface",
    "Dupioni Silk - Crisp raw silk with irregular slub texture for depth",
    "Lace - Intricate openwork patterns in various weights and designs",
    "Beaded Embroidery - Embellished with beads and pearls for texture and shimmer",
    "Sequin Embellishment - Covered with sequins for high-impact sparkle",
  ],
} as const;

// Client-side rate limiting constants
export const CLIENT_RATE_LIMITS = {
  GENERATE_BUTTON_COOLDOWN: 3000, // 3 seconds
  MAX_CONCURRENT_GENERATIONS: 1,
} as const;
